import axios from 'axios'

export default {
  image_compression(slug) {
    return axios.get(`/api/tests/${slug}/image_compression`).then(response => response.data)
  }
}

